import { render, staticRenderFns } from "./DiscoverHeader.vue?vue&type=template&id=6e2d0930&scoped=true"
import script from "./DiscoverHeader.vue?vue&type=script&lang=js"
export * from "./DiscoverHeader.vue?vue&type=script&lang=js"
import style0 from "./DiscoverHeader.vue?vue&type=style&index=0&id=6e2d0930&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2d0930",
  null
  
)

export default component.exports